var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.gameLink)?_c('iframe',{attrs:{"id":"game","src":_vm.gameLink}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }